import {
  WORKFLOW_METADATA_SET_LOADING,
  WORKFLOW_METADATA_SET_DATA,
  WORKFLOW_METADATA_SET_ERROR,
  WORKFLOW_METADATA_CLEAR_EVENTS,
} from '../actions/constants';

const defaultState = {
  fieldListMetadata: {},
  eventMetadata: {},
  errorMessage: null,
  isLoading: false,
};

export default function (state: any = defaultState, action) {
  switch (action.type) {
    case WORKFLOW_METADATA_SET_LOADING:
      return {
        ...state,
        isLoading: action.data,
      };

    case WORKFLOW_METADATA_SET_DATA:
      return {
        ...state,
        fieldListMetadata: {
          ...state.fieldListMetadata,
          ...action.data.fieldListMetadata,
        },
        eventMetadata: {
          ...state.eventMetadata,
          ...action.data.eventMetadata,
        },
        errorMessage: null,
      };

    case WORKFLOW_METADATA_SET_ERROR:
      return {
        ...state,
        errorMessage: action.data,
      };

    case WORKFLOW_METADATA_CLEAR_EVENTS:
      return {
        ...state,
        eventMetadata: {
          ...state.eventMetadata,
          [action.data.objectType]: null,
        },
      };

    default:
      return state;
  }
}
